<template>
  <div class="root">
    <span class="title">融资查询</span>
    <el-form
      ref="form"
      :model="form"
      label-width="180px"
      :inline="true"
      id="selectForm">
      <el-form-item label="位 置 :">
        <!-- <label slot="label">位&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;置 :</label> -->
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item label="登记编号 :">
        <el-input v-model="form.cid"></el-input>
      </el-form-item>
      <el-button @click="chaxun" type="danger" class="search-btn" size="medium "
        >开始查询</el-button
      >
    </el-form>

    <!-- <div style="display: flex;font-size: 30px;width: 400px;align-items: center;margin-left:30px;position: relative;">
      <span style="width: 22%;">位 置 :</span>
      <input style="border-radius: 8px;width: 50%;height: 40px;font-size: 20px;padding: 0 10px;" type="text"
        v-model="form.address">
    </div>
    <div style="display: flex;font-size: 30px;width: 400px;align-items: center;">
      <span style="width: 35%;">登记编号 :</span>
      <input style="border-radius: 8px;width: 50%;height: 40px;font-size: 20px;padding: 0 10px;" type="text"
        v-model="form.cid">
    </div>
    <router-link :to="{ name: '融资公告', query: form }" class="search">开始查询</router-link> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        address: '',
        cid: '',
      },
    }
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    chaxun() {
      this.$router.push({ name: '融资公告', query: this.form })
    },
  },
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  width: 100%;
  height: 390px;
  display: flex;
  flex-direction: column;
  /* line-height: 80px; */
  /* background-color: pink; */
  box-sizing: border-box;
  margin-bottom: 20px;
  /* padding: 0 30px; */
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  padding: 5px;
}

.title {
  /* margin-left: 20px; */
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  /* line-height: 80px; */
  border-bottom: 1px solid #2187ff;
  padding-left: 30px;
}

.root >>> .el-form--inline .el-form-item__content {
  vertical-align: middle;
}

.search-btn {
  margin-left: 230px;
  position: relative;
  top: -6px;
}

.el-form-item__label {
  width: 30px;
}

#selectForm >>> .el-form-item__label {
  font-size: 20px;
}
</style>
